<h2 mat-dialog-title>{{ data.title }}</h2>
<mat-dialog-content>
    <span>{{ data.content }}</span>
    <mat-form-field>
        <mat-label>{{ data.label }}</mat-label>
        @if (isTextArea) {
        <textarea
            matInput
            type="text"
            [formControl]="inputTextControl"
            [maxLength]="data.maxLength"
            cdkFocusInitial
            [cdkTextareaAutosize]="true"
            [cdkAutosizeMinRows]="data.minRows"
            [cdkAutosizeMaxRows]="data.maxRows"
        ></textarea>
        } @else {
        <input
            matInput
            type="text"
            [formControl]="inputTextControl"
            [maxLength]="data.maxLength"
            cdkFocusInitial
        />
        } @if (inputTextControl.errors?.required) {
        <mat-error> {{ data.label || 'Valor' }} é obrigatório. </mat-error>
        } @if (inputTextControl.errors?.minlength) {
        <mat-error>
            {{ data.label || 'Valor' }} deve ter pelo menos {{ data.minLength }} caracteres.
        </mat-error>
        } @if (inputTextControl.errors?.maxlength) {
        <mat-error>
            {{ data.label || 'Valor' }} deve no máximo {{ data.maxLength }} caracteres.
        </mat-error>
        } @if (inputTextControl.errors?.pattern) {
        <mat-error> {{ data.label || 'Valor' }} informado é inválido. </mat-error>
        }
    </mat-form-field>
</mat-dialog-content>
<mat-dialog-actions>
    <button
        mat-raised-button
        type="button"
        color="accent"
        [mat-dialog-close]="inputTextControl.value"
        [disabled]="inputTextControl.invalid"
    >
        Confirmar
    </button>
    <button mat-button type="button" color="warn" mat-dialog-close>Cancelar</button>
</mat-dialog-actions>
